import { isError } from './isError';
import { isString } from './isString';
import { UNAVAILABLE } from './constants';
/**
 * Parse the error object.
 *
 * @param error - The error to parse.
 * @returns An object with error message and stack, or false if the parameter does not have the format we use.
 */
export function getErrorData(error) {
    if (isString(error)) {
        return {
            message: error,
            stack: UNAVAILABLE
        };
    }
    else if (isError(error)) {
        return {
            message: isString(error.message) ? error.message : UNAVAILABLE,
            stack: isString(error.stack) ? error.stack : UNAVAILABLE
        };
    }
    return false;
}
